




import { Component, Vue } from "vue-property-decorator";
import EventBus from './event-bus';
import {API_WS_URL} from './http';

@Component
export default class Emma extends Vue 
{
    needRefresh: boolean = false;
    
    created() {
        EventBus.$on( 'refresh-entire-route', () => {
            this.needRefresh = !this.needRefresh;
        });
    }
}
